import { useEffect, useState } from "react";
import NavBarFixed from '../Navbar/NavbarFixed.js';
import Footer from '../Footer.js';
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import './markdown.css';
import { useConfig } from 'context/ConfigContext.js'; // New import

function MarkdownPage() {
  const { filename } = useParams();
  const [markdownContent, setMarkdownContent] = useState("");
  const config = useConfig(); // Use the hook

  useEffect(() => {
    // We need to make sure config is available before we fetch and process
    if (!config) {
      return;
    }

    fetch(`/${filename}.md`)
      .then((response) => response.text())
      .then((text) => {
        const processedText = text.replace(/__MAIN_APP_NAME__/g, config.appName)
		.replace(/__FULL_COMPANY_NAME__/g, config.fullCompanyName)
		.replace(/__SHORT_COMPANY_NAME__/g, config.shortCompanyName)
		.replace(/__EMAIL_FOR_SUPPORT__/g, config.emailForSupport.toLowerCase());
        setMarkdownContent(processedText);
      });
  }, [filename, config]); // Add config as a dependency to the useEffect hook

  //return <ReactMarkdown>{markdownContent}</ReactMarkdown>;
  return (
        <div>
            <div>
                <NavBarFixed isHomePage={false}/>
            </div>
            <div id='Hello' className="flex justify-center items-center mt-8 w-full bg-white py-12 lg:py-24">
                <div className="container my-8 px-4 lg:px-20">

                <ReactMarkdown>{markdownContent}</ReactMarkdown>
            </div>
            </div>
            <Footer />
        </div>

    )
}

export default MarkdownPage;